import _get from 'lodash/get';

export function selectTimezones(state) {
  return _get(state, 'business.timezones.value', []);
}
